<template>
	<div class="merchant-closed">
		<img src="@/assets/images/index/closed.png" alt="当前商户已关闭" />
		<h2>当前商户已关闭</h2>

		<div v-if="recommendWarehouse" class="recommend-merchant">
			<div class="recommend-header">
				<span class="recommend-icon">
					<i class="el-icon-office-building"></i>
				</span>
				<div>
					<strong class="recommend-title">推荐商户</strong>
					<p class="recommend-label">以下商户仍在正常运营，可切换后继续访问</p>
				</div>
			</div>
			<div class="recommend-name">
				<span>{{ recommendWarehouse.warehouse_name || "推荐商户" }}</span>
				<em>营业中</em>
			</div>
			<el-button class="switch-button" type="primary" :loading="switching" @click="switchMerchant">
				切换到该商户<i class="el-icon-arrow-right el-icon--right"></i>
			</el-button>
		</div>
		<p v-else class="no-recommend">暂无其他正在运营的商户，请稍后再来</p>
	</div>
</template>

<script>
import { normalizeWarehouseHost, setWarehouseHost } from "@/utils/warehouseStorage"

export default {
	name: "MerchantClosed",
	data() {
		return {
			switching: false
		}
	},
	computed: {
		siteInfo() {
			return this.$store.getters.siteInfo || {}
		},
		recommendWarehouse() {
			return this.siteInfo.recommend_warehouse || null
		}
	},
	methods: {
		switchMerchant() {
			if (this.switching || !this.recommendWarehouse) return

			const targetHost = normalizeWarehouseHost(this.recommendWarehouse.domain)
			if (!targetHost) {
				this.$message.error("推荐商户地址无效，暂时无法切换")
				return
			}

			this.switching = true
			const warehouseHost = setWarehouseHost(targetHost)
			if (!warehouseHost) {
				this.switching = false
				this.$message.error("浏览器存储不可用，暂时无法切换商户")
				return
			}

			// 推荐数据不包含目标商户的登录账号，清理旧商户登录态后进入新商户。
			this.$store.dispatch("member/remove_token")
			window.location.replace("/index")
		}
	}
}
</script>

<style lang="scss" scoped>
.merchant-closed {
	position: absolute;
	top: 50%;
	left: 50%;
	box-sizing: border-box;
	width: 520px;
	padding: 40px;
	text-align: center;
	transform: translate(-50%, -50%);

	img {
		display: block;
		max-width: 100%;
		margin: 0 auto 24px;
	}

	h2 {
		margin: 0 0 12px;
		color: #333;
		font-size: 24px;
		font-weight: 500;
	}

	.no-recommend {
		margin: 0;
		color: #999;
		font-size: 14px;
	}

	.recommend-merchant {
		margin-top: 28px;
		padding: 22px 24px 24px;
		border: 1px solid #ebeef5;
		border-radius: 10px;
		background: #fff;
		box-shadow: 0 8px 24px rgba(31, 45, 61, 0.07);
		text-align: left;

		.recommend-header {
			display: flex;
			align-items: center;
		}

		.recommend-icon {
			display: flex;
			flex: 0 0 42px;
			align-items: center;
			justify-content: center;
			height: 42px;
			margin-right: 14px;
			border-radius: 50%;
			background: rgba(255, 84, 120, 0.1);
			color: $base-color;
			font-size: 20px;
		}

		.recommend-title {
			display: block;
			margin-bottom: 4px;
			color: #303133;
			font-size: 16px;
			font-weight: 500;
		}

		.recommend-label {
			margin: 0;
			color: #999;
			font-size: 13px;
			line-height: 20px;
		}

		.recommend-name {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 20px 0;
			padding: 16px;
			border-radius: 6px;
			background: #f7f8fa;

			span {
				min-width: 0;
				padding-right: 16px;
				color: #303133;
				font-size: 17px;
				font-weight: 600;
				line-height: 26px;
				word-break: break-word;
			}

			em {
				flex: 0 0 auto;
				padding: 3px 9px;
				border-radius: 12px;
				background: #e9f8ef;
				color: #31a56a;
				font-size: 12px;
				font-style: normal;
			}
		}

		.switch-button {
			width: 100%;
			height: 42px;
			border-radius: 6px;
			font-size: 15px;
		}
	}

	.no-recommend {
		margin-top: 24px;
	}
}

@media screen and (max-width: 600px) {
	.merchant-closed {
		width: 100%;
		padding: 24px;

		.recommend-merchant {
			padding: 20px;

			.recommend-header {
				align-items: flex-start;
			}

			.recommend-name {
				align-items: flex-start;
			}
		}
	}
}
</style>
